/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { optimizedAgentMemoryControllerOptimize } from "./optimizedAgentMemoryControllerOptimize";

export function optimizedAgentMemoriesService() {
  return { optimizedAgentMemoryControllerOptimize }
}